import ActionTextIcon from "@/components/icons/ActionTextIcon";
import { Tooltip } from "antd";
import { useTranslation } from "react-i18next";

type Props = {
  type?: "percentage" | "number";
  value: number;
};

export const TrendIndicator = ({ type = "percentage", value }: Props) => {
  const { t } = useTranslation();

  if (value === 0) {
    return (
      <Tooltip title={t("dashboard.helpers.lastYearChange")}>
        <span>
          <ActionTextIcon
            icon={"stock"}
            text={`${value} ${type === "percentage" ? "%" : ""}`}
            color="grey"
            customMarginIcon={4}
          />
        </span>
      </Tooltip>
    );
  }

  const isPositive = value > 0;

  return (
    <Tooltip title={t("dashboard.helpers.lastYearChange")}>
      <span>
        <ActionTextIcon
          className="bold-text"
          icon={isPositive ? "rise" : "fall"}
          text={`${value} ${type === "percentage" ? "%" : ""}`}
          color={isPositive ? "green" : "red"}
          customMarginIcon={4}
        />
      </span>
    </Tooltip>
  );
};
